import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsVehiclesDetailList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsVehiclesDetail/ReportsVehiclesDetailList/ReportsVehiclesDetailList"
    )
);
export const ReportsVehiclesDetail = () => {
  return (
    <Layout>
      <ReportsVehiclesDetailList />
    </Layout>
  );
};
